"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import DatasItems from "@/views/costItems/components/DatasItems.vue";
import API from "@ym-framework/api-utils";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import CouponDataItem from "@/views/costItems/components/CouponDataItem.vue";
import UiDialog from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import UiSubmit from "@/components/form/UiSubmit.vue";
import i18n from "@/lang";
const _gridController = new GridController(new APIDataSource("api://base.auth/api/v7/discount_coupons_bypage"));
class AddCouponFormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.coupon_code = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("couponitem.please_enter_the_exchange_code"),
      trigger: "blur"
    }
  ])
], AddCouponFormController.prototype, "coupon_code", 2);
let CouponItem = class extends Vue {
  constructor() {
    super(...arguments);
    this.gridController = _gridController;
    this.uiFormConttoller = new AddCouponFormController();
    this.couponOptions = [
      {
        label: this.$t("couponitem.all"),
        value: null
      },
      {
        label: this.$t("couponitem.available"),
        value: 0
      },
      {
        label: this.$t("couponitem.used"),
        value: 1
      },
      {
        label: this.$t("couponitem.expired"),
        value: 3
      }
    ];
    this.coupon = 0;
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.query.filter = `type==null;status==0`;
      this.gridController.pagePosition = "dialog";
      this.gridController.query.current = 1;
      yield this.gridController.search();
    });
  }
  goBack() {
    this.$router.go(-1);
  }
  couponSearch() {
    return __async(this, null, function* () {
      if (this.coupon === null) {
        this.gridController.query.filter = `type==null`;
      }
      if (this.coupon !== null) {
        this.gridController.query.filter = `type==null;status==${this.coupon}`;
      }
      yield this.gridController.search();
    });
  }
  refreshCoupon() {
    return __async(this, null, function* () {
      yield this.gridController.search();
    });
  }
  OpenCouponAdd() {
    this._couponDialog.show();
  }
  toCoupon() {
    return __async(this, null, function* () {
      try {
        let response = yield API.post(`api://base.auth/api/v7/discount_coupon_exchanges/exchange_discount_coupon`, {
          "exchange_code": this.uiFormConttoller.coupon_code
        });
        this.$message.success(this.$t("couponitem.the_exchange_code_was_successfully_used_"));
        yield this.refreshCoupon();
        this.dialogclose();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  dialogclose() {
    this.uiFormConttoller.coupon_code = "";
    this._couponDialog.hide();
  }
};
__decorateClass([
  Ref("coupon-add")
], CouponItem.prototype, "_couponDialog", 2);
CouponItem = __decorateClass([
  Component(
    {
      components: {
        UiSubmit,
        UiDialog,
        UiForm,
        CouponDataItem,
        UiGrid,
        DatasItems
      }
    }
  )
], CouponItem);
export {
  CouponItem as default
};
